module.exports = __webpack_public_path__ + "static/media/1023530.a99c3304.png";